module.exports = __webpack_public_path__ + "static/media/background-circle.44c72084.png";